/* eslint-disable react-hooks/exhaustive-deps */
import Badge from '@panel/commons/lib/badge';
import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { InboxOperations, InboxSelectors } from '@panel/leads/src/components/menuInbox/ducks';
import { useObserver } from 'mobx-react';
import { useDispatch, useSelector } from 'react-redux';
import { getColor } from '@panel/commons/core/themev3';

const deskTopStyle = css`
  position: absolute;
  right: -4px;
  top: 5px;
  z-index: 1;
`;

const mobileStyle = css`
  position: relative;
  margin-left: 8px;
`;

const BadgeWrapper = styled.div`
  ${({ isMobile }) => (isMobile ? mobileStyle : deskTopStyle)}
`;

const LeadCounterContainer = ({ isMobile = false }) => {
  const dispatch = useDispatch();
  const unReadTotal = useSelector(InboxSelectors.getInboxUnReadState);
  const inbox = useSelector(InboxSelectors.getInboxStatus);

  useEffect(() => {
    dispatch(InboxOperations.fetchUnread(inbox.status, isMobile));
  }, []);

  return useObserver(() => (
    <BadgeWrapper isMobile={isMobile}>
      {unReadTotal !== undefined && unReadTotal > 0 && (
        <Badge as='div' value={unReadTotal > 999 ? '+999' : unReadTotal} color={getColor('primary')} />
      )}
    </BadgeWrapper>
  ));
};

export default LeadCounterContainer;
